import React from 'react';
import { FormattedMessage } from 'react-intl';
import { observer } from 'mobx-react';
import { action } from 'mobx';
import emojione from 'lib/emojione/emojione';
import Styled from 'styled';

import { replace } from 'lib/emojione/ascii-mapping';
import Localizable from 'lib/intl/localizable';
import { Form, Field } from 'lib/form/form';
import withDialog from 'lib/alerts/with-dialog';
import { ValueFieldData, RequiredValidator } from 'lib/form/value-field-data';

import withStackViewForm from 'four-nets/ui/with-stack-view-form';
import SubmitButtonView from 'four-nets/ui/submit-button/submit-button-view';
import TextAreaView from 'four-nets/ui-v2/form/text-area/text-area';
import FieldWithLabelView from 'four-nets/ui/form/field-with-label-view';

import FormView from './form/form-view';
import defaultStyles from './edit-comment-view.scss';

export class EditCommentViewModel {
    comment: Comment;

    constructor(options: { comment: Comment }) {
        const { comment } = options;

        this.comment = comment;
    }

    handleSubmit = ({
        data,
    }: {
        data: {
            body: ?string,
        },
    }) => {
        const { body } = data;
        return this.comment.updateContent(emojione.toShort(replace(body)));
    };

    @action setupForm = () => {
        const form = new Form({
            field: {
                body: new Field({
                    data: new ValueFieldData({
                        value: this.comment.body,
                        validators: [new RequiredValidator()],
                    }),
                }),
            },
            handleSubmit: this.handleSubmit,
        });
        return form;
    };
}

@Localizable()
@withStackViewForm({
    hideAction: true,
    title: <FormattedMessage id='FORUM_FORM_TITLE_EDIT_COMMENT' />,
})
@withDialog
@Styled(defaultStyles)
@observer
class EditCommentView extends React.Component {
    render() {
        const {
            submit,
            form,
            styles,
            intl: { _ },
        } = this.props;
        const { valid, dirty } = form;

        return (
            <FormView form={form} submitOnEnter={false} submit={submit}>
                <FieldWithLabelView
                    field={
                        <TextAreaView
                            style={{ textArea: styles.textArea }}
                            field={form.field.get('body')}
                            type='text'
                            emojify={true}
                        />
                    }
                    label={<FormattedMessage id='FORM_FIELD_LABEL_BODY' />}
                    mini={true}
                />
                <div className={styles.field}>
                    <SubmitButtonView disabled={!(valid && dirty)} onClick={submit}>
                        <span className={styles.label}>{<FormattedMessage id='BUTTON_LABEL_SAVE' />}</span>
                    </SubmitButtonView>
                </div>
            </FormView>
        );
    }
}

export default EditCommentView;
